import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const appearanceRouteRoot: ManifestRouteDefinition = {
  key: 'appearance',
  path: '/appearance',
  apiCalls: [
    { url: '/tenant/ui/single/config', method: 'GET' },
    { url: '/tenant/ui/single/config', method: 'PATCH' },
    { url: '/uploads/images', method: 'POST' },
    { url: '/tenants/rbac/users/:userId/module-config', method: 'GET' },
    { url: '/tenants/rbac/modules', method: 'GET' },
    { url: '/tenants/rbac/modules/:moduleId/features', method: 'GET' },
    { url: '/tenants/rbac/module-config', method: 'POST' },
  ],
  lazyComponent: () =>
    import('@/features/appearence/pages/AppearanceLayout/AppearanceLayout').then((m) => ({
      default: m.default,
    })),
  indexRedirect: 'branding',
  children: [
    {
      key: 'appearance_branding',
      path: 'branding',
      apiCalls: [
        { url: '/tenant/ui/single/config', method: 'GET' },
        { url: '/uploads/images', method: 'POST' },
        { url: '/tenant/ui/single/config', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/appearence/pages/AppearanceBrandingPage/AppearanceBrandingPage').then(
          (m) => ({
            default: m.default,
          })
        ),
    },
    {
      key: 'appearance_login',
      path: 'login-screen-setup',
      apiCalls: [
        { url: '/tenant/ui/single/config', method: 'GET' },
        { url: '/uploads/images', method: 'POST' },
        { url: '/tenant/ui/single/config', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/appearence/pages/AppearanceLoginScreenPage/AppearanceLoginScreenPage').then(
          (m) => ({
            default: m.default,
          })
        ),
    },
    {
      key: 'appearance_nav',
      path: 'navigation-builder',
      apiCalls: [
        { url: '/tenants/rbac/users/:userId/module-config', method: 'GET' },
        { url: '/tenants/rbac/modules', method: 'GET' },
        { url: '/tenants/rbac/modules/:moduleId/features', method: 'GET' },
        { url: '/tenants/rbac/module-config', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/appearence/pages/AppearanceNavigationPage/AppearanceNavigationPage').then(
          (m) => ({
            default: m.default,
          })
        ),
    },
  ],
}
